import React from 'react';
import { connect } from 'dva';
import { templateConfig, reduxTemplateConfig } from './config'

import { framework_tool,utils_tool,component_tool } from '@/tool'
import handleFile from "@/utils/downloadExcelUtils";
let { WizContainer, WizReduxTemplate } = framework_tool;
let {  WizBrowserExport } = component_tool;
let { checkStrLength } = utils_tool;

class BankQuestion extends WizContainer {

  componentName = 'BankQuestion';

  constructor(props) {
    super(props);
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    const _templateConfig = templateConfig(this)
    let _reduxTemplateConfig = reduxTemplateConfig({
      templateConfig: _templateConfig,
      apiDataFormat: {
        export: handleFile.bind(this, _templateConfig?.content?.params?.columns, '检核任务'),
      },
    })
    return <WizReduxTemplate {..._reduxTemplateConfig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(BankQuestion);
